/**
 * Allowed attribute categories for Pre-IPO Attribute Catalog.
 * Used in create/edit form and category filter.
 */
export const ATTRIBUTE_CATEGORIES = [
  { value: 'description', label: 'Description' },
  { value: 'Overview Details', label: 'Overview Details' },
  { value: 'Risks', label: 'Risks' },
  { value: 'Reasons to Invest', label: 'Reasons to Invest' },
];
